import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { FilterListComponent } from 'gung-list';
import {
  AuthService,
  Product,
  ProductListComponent
} from 'gung-standard';
import { first } from 'rxjs';
import { OttoOlsenModalService } from '../../services/otto-olsen-modal.service';

@Component({
    selector: 'otto-olsen-product-list',
    template: '<lib-filter-list #productList [configService]="productListConfigService" [topFilter]="true"></lib-filter-list>',
    styleUrls: ['./otto-olsen-product-list.component.scss'],
    standalone: false
})
export class OttoOlsenProductListComponent extends ProductListComponent implements OnInit {
  private authService = inject(AuthService);
  private modalService = inject(OttoOlsenModalService);

  @ViewChild('productList') productList: FilterListComponent<Product>;

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      const assortmentId = params.get('assortmentId');

      if (assortmentId != null) {
        this.productListConfigService.assortmentSubject.next(assortmentId);
      } else {
        this.authService
          .getCurrentUser()
          .pipe(first())
          .subscribe(user => this.productListConfigService.assortmentSubject.next(user.assortment));
      }

      // Product Details
      const productId = params.get('productId');

      if (productId != null) {
        this.modalService.openProductDetailsModal(productId);
      }
      if (this.productList) {
        this.productList.renderNewLayout();
        this.productList.renderNewFilters();
      }
    });
  }
}
